import React, { useEffect, useState } from 'react'
import { getGroups } from '../../api/getNomenclatures'
import { FormControl, FormLabel, Select, Spinner } from '@chakra-ui/react'
import { LABEL } from '../../../../constants'

const GroupsDropDown = ({ value, onChange, groups, loading }) => {
  return (
    <FormControl>
      <FormLabel textColor="gray.500" mb="0" fontSize="sm">
        {LABEL.GROUP_DROPDOWN.label}
      </FormLabel>
      {loading ? (
        <Spinner size="sm" />
      ) : (
        <Select
          bg="white"
          borderRadius="lg"
          size="sm"
          border="1px"
          borderColor="black"
          value={value ?? ''}
          onChange={(e) => {
            const raw = e.target.value
            const selected = raw === '' ? null : raw
            onChange(selected)
          }}
          placeholder={LABEL.GROUP_DROPDOWN.placeholder}
        >
          {groups.map((group, index) => (
            <option key={index} value={group}>
              {group}
            </option>
          ))}
        </Select>
      )}
    </FormControl>
  )
}

export default GroupsDropDown
